import { animate, query, stagger, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { TemplatesFacade } from '@quorum/xsr-template-library';
import { truncate } from 'fs';
import { Observable } from 'rxjs';

@Component({
  selector: 'quorum-design',
  templateUrl: './design.component.html',
  styleUrls: ['./design.component.scss'],
  animations: [
    // the fade-in/fade-out animation.
    trigger('simpleFadeAnimation', [
      // the "in" style determines the "resting" state of the element when it is visible.
      transition('* => *', [
        query(':enter', [style({ opacity: 0 }), stagger(280, [style({ opacity: 1 }), animate('400ms')])], {
          optional: true,
        }),
      ]),
    ]),
  ],
})
export class DesignComponent implements OnInit {
  loading = false;
  constructor(public authenticationStateService: AuthenticationStateService, public templateFacade: TemplatesFacade) {}

  ngOnInit(): void {
    // let images: string[] = [];
    // templates.forEach((template: Template) => {
    //   images.push(template.previewImageUrl);
    // });
    // this.templates = templates;
    // this.filteredTemplates = templates;
    // from(images)
    //   .pipe(concatMap(this.loadImage), toArray())
    //   .subscribe(function (images) {
    //     that.loading = false;
    //   });
  }

  loadImage(imagePath: string) {
    return new Observable(function (observer: any) {
      var img = new Image();
      img.src = imagePath;
      img.onload = function () {
        observer.next(img);
        observer.complete();
      };
      img.onerror = function (err) {
        observer.onError(err);
      };
    });
  }
}
